/* eslint-disable func-names, prefer-template */
/* globals Helpers, DocLang, DocMenus */

window.DocCodeMenu = {
  setup($body) {
    this.codemenu = $('[data-js-codelang-menu]');

    $body.on('click', '.code-menu-toggle > a', function () {
      $(this).closest('.code-menu').toggleClass('code-menu-collapsed');
      return false;
    });

    const setLanguage = (lang) => {
      this.setLanguage(lang);
    };

    this.codemenu.on('click', 'button', function () {
      const $this = $(this);
      const lang = $this.parent().data('lang');
      $('[data-js-docs-loader]').removeClass('not-loading');

      // SetLanguge freezes the DOM due its intense DOM manipulation
      // TimeOut necessary to display a loader before it becomes freezed
      // Making sure that the user knows what's going on.
      // Yup not proud of it
      setTimeout(function () {
        setLanguage(lang);
        setTimeout(() => $('[data-js-docs-loader]').addClass('not-loading'), 10);
      }, 150);

      // Resets the slide popup functions
      $('body').trigger('rendered');
    });

    $('[data-lang-code-group]').on('click', 'button', DocLang.switchDisplayedBlockButtonEvent);
  },

  setLanguage(lang, options) {
    Helpers.setCurrentLanguage(lang, options);

    const $button = this.codemenu.find('li[data-lang="' + lang + '"] button');
    Helpers.activateButton($button);

    // Find all contiguous code blocks with menus to select lang
    // If the current lang is not supported, then show the menu
    // Else hide the menu
    $('.code-window').each(function () {
      // show inline toolbar if mode not available
      const $codeWinMenu = $('.code-window-menu', this);
      if (!$(this).find('[data-mode="' + lang + '"]').length) {
        $codeWinMenu.removeClass('hidden').find('.toolbar-mode').text(Helpers.capitalize(lang));
      } else {
        $codeWinMenu.addClass('hidden');
      }
    });

    // trigger click on code window toolbar
    $('.code-window-menu button[data-mode="' + lang + '"]').trigger('click');

    DocLang.showLanguageSpecificContentAndCode();
    document.dispatchEvent(
      new CustomEvent('docs:set-language', {
        lang,
      }),
    );

    // setup jump menu based on new available items
    DocMenus.setCurSection();
  },
};
